import type { SlateLeaf } from '@atlas/renderer';
import { Transforms, Element, Editor } from 'slate';

export default function withoutFormattingInsideCodeBlock(editor: Editor) {
    const { normalizeNode } = editor;

    editor.normalizeNode = (entry) => {
        const [node, path] = entry;
        if (!Element.isElement(node) || node.type !== 'code-block') {
            return normalizeNode(entry);
        }

        Editor.withoutNormalizing(editor, () => {
            node.children.forEach((leaf, index) => {
                const leafKeys = Object.keys(leaf) as Array<keyof SlateLeaf>;
                const invalidLeafKeys = leafKeys.filter((key) => !textFeaturesWhiteList.includes(key));
                if (invalidLeafKeys.length) {
                    const leafPatch = invalidLeafKeys.reduce((acc, key) => Object.assign(acc, { [key]: null }), {});
                    Transforms.setNodes(editor, leafPatch, { at: path.concat(index) });
                }
            }, []);
        });
    };

    return editor;
}

// #region Helpers

const textFeaturesWhiteList: Array<keyof SlateLeaf> = ['text', 'link'];

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('withoutFormattingInsideCodeBlock', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
